exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*base-link-mixin*/\n.leaderboard {\n  width: 100%;\n  max-width: 1140px;\n  margin-bottom: 15px; }\n  .leaderboard img {\n    width: 100%;\n    max-height: 80px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/banner-leaderboard/banner-leaderboard.component.scss
// module id = 876
// module chunks = 22